import React from 'react';

import { CustomerInfo, SiteCoreDictionary } from '../types';

import './CardWillBeSentToAddress.scss';

type CityWithPostalCodeProps = {
    customerInfo: CustomerInfo | undefined;
};

const CityWithPostalCode = ({ customerInfo }: CityWithPostalCodeProps) => {
    if (!customerInfo?.customerAddress) {
        return null;
    }
    const { city, postalCode } = customerInfo.customerAddress;
    if (typeof city === 'undefined') {
        if (typeof postalCode === 'undefined') {
            return null;
        }

        return <p>{postalCode}</p>;
    }

    if (typeof postalCode === 'undefined') {
        return <p>{city}</p>;
    }

    return <p>{`${postalCode} ${city}`}</p>;
};

interface CardWillBeSentToAddressProps {
    customerInfo: CustomerInfo | undefined;
    dictionary: SiteCoreDictionary;
}

export const CardWillBeSentToAddress = ({ customerInfo, dictionary }: CardWillBeSentToAddressProps) => {
    const { orderCardAddressHeader, orderCardAddressText } = dictionary;

    if (typeof customerInfo === 'undefined') {
        return null;
    }

    const { customerAddress } = customerInfo;

    if (typeof customerAddress === 'undefined') {
        return <p>{orderCardAddressText}</p>;
    }

    const { address } = customerAddress;

    return (
        <div className="address-information">
            <p>{orderCardAddressHeader}</p>
            <div className="address-details">
                {address.map((addressName) => (
                    <p key={addressName}>{addressName}</p>
                ))}
                <CityWithPostalCode customerInfo={customerInfo} />
            </div>
        </div>
    );
};
